export default __webpack_public_path__ + "static/media/profuturo-logo-small.ce06f30f.png";